import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';
import type { ReviewSummary } from '@/types';

interface RatingBreakdownProps {
  summary: ReviewSummary;
}

const STAR_LEVELS = [5, 4, 3, 2, 1] as const;

export function RatingBreakdown({ summary }: RatingBreakdownProps) {
  const total = summary.reviewCount || 1;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {STAR_LEVELS.map((stars) => {
        const count = summary.breakdown[String(stars)] ?? 0;
        const percent = (count / total) * 100;

        return (
          <Box key={stars} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Typography variant="body2" sx={{ width: 28, fontWeight: 600 }}>
              {stars}★
            </Typography>
            <LinearProgress
              variant="determinate"
              value={percent}
              sx={{
                flex: 1,
                height: 8,
                borderRadius: 4,
                bgcolor: 'grey.100',
                '& .MuiLinearProgress-bar': { borderRadius: 4 },
              }}
            />
            <Typography variant="caption" color="text.secondary" sx={{ width: 24, textAlign: 'right' }}>
              {count}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}
